import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Lockup, ASSETS } from "@/lib/brand";

export default function Entry() {
  const navigate = useNavigate();
  const [cfg, setCfg] = useState({ store_login_url: "", policies: {} });

  useEffect(() => {
    api.get("/public-config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  const policy = (k) => cfg.policies?.[k] || "#";

  return (
    <div className="min-h-screen flex flex-col px-6 relative overflow-hidden" style={{ backgroundColor: "#F3EEE4" }} data-testid="entry-screen">
      <img src={ASSETS.boutique} alt="" className="absolute inset-0 w-full h-full object-cover opacity-[0.12]" />
      <div className="relative flex-1 flex flex-col items-center justify-center">
        <div className="w-full max-w-md text-center space-y-12">
          <div className="space-y-5">
            <h1 className="sr-only">SERENISMM</h1>
            <Lockup height={128} className="mx-auto" />
            <p className="text-[11px] tracking-[0.5em] text-[#A98F63] pt-3">ONE SOUL, ONE UNIVERSE</p>
            <p className="text-[10px] tracking-[0.5em] text-[#9C907A] pt-2">PRIVATE ACCESS</p>
          </div>
          <div className="space-y-4">
            <Button data-testid="enter-invitation-btn"
              className="w-full h-12 tracking-[0.25em] text-xs bg-[#2E2A22] text-[#F3EEE4] hover:bg-[#201C15]"
              onClick={() => navigate("/validate")}>
              ENTER INVITATION CODE
            </Button>
            <Button data-testid="member-signin-btn" variant="outline"
              className="w-full h-12 tracking-[0.25em] text-xs border-[#C9BCA2] bg-transparent text-[#2E2A22] hover:bg-[#E8DFCF]"
              onClick={() => { if (cfg.store_login_url) window.location.href = cfg.store_login_url; }}>
              MEMBER SIGN IN
            </Button>
          </div>
          <div className="flex items-center justify-center gap-6 pt-2">
            <button data-testid="entry-about-serenismm" onClick={() => navigate("/about-serenismm")}
              className="text-[10px] tracking-[0.3em] text-[#9C907A] hover:text-[#2E2A22] uppercase">About SERENISMM</button>
            <span className="text-[#C9BCA2]">·</span>
            <button data-testid="entry-about-founder" onClick={() => navigate("/about-founder")}
              className="text-[10px] tracking-[0.3em] text-[#9C907A] hover:text-[#2E2A22] uppercase">The Founder</button>
          </div>
        </div>
      </div>

      <footer className="relative py-8 text-center">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[10px] tracking-[0.28em] text-[#9C907A] uppercase">
          <a data-testid="footer-refund" href={policy("refund")} target="_blank" rel="noreferrer" className="hover:text-[#2E2A22]">Refund Policy</a>
          <a data-testid="footer-privacy" href={policy("privacy")} target="_blank" rel="noreferrer" className="hover:text-[#2E2A22]">Privacy</a>
          <a data-testid="footer-terms" href={policy("terms")} target="_blank" rel="noreferrer" className="hover:text-[#2E2A22]">Terms</a>
          <a data-testid="footer-shipping" href={policy("shipping")} target="_blank" rel="noreferrer" className="hover:text-[#2E2A22]">Shipping</a>
          <button data-testid="footer-contact" onClick={() => navigate("/contact")} className="hover:text-[#2E2A22] uppercase tracking-[0.28em]">Contact</button>
        </div>
      </footer>
    </div>
  );
}
